import variables from './_variables.scss'

const colorPrefix = 'color-'
const chipScalePrefix = 'chip-scale-'

export const getColor = (color, opacity = '') => {
  const paletteColor = color && variables[`${colorPrefix}${color}`]
  return (paletteColor && `${paletteColor}${opacity}`) || color
}

export const colors = Object.keys(variables)
  .filter(color => color.indexOf(colorPrefix) === 0)
  .map(color => color.substring(colorPrefix.length))

export const sizes = ['xs', 'sm', 'md', 'lg', 'xl']

export const baseChipSize = Number(variables['base-chip-size'])
export const getChipScale = (size = 'md') => Number(variables[`${chipScalePrefix}${size}`])
